export class FiltrosSolicitudDes{

    IdSolicitudDesembolso : string = '';
    IdAd : string = '';
    IdProv : string = '';
    Estado : string = 'P';
    Moneda : string = '';

}